import ExercisePage from "../components/ExercisePage";

export default function Passagepage() {
  return <ExercisePage isPaperBank={false} />;
}
